module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 8-5c4fcf78c427a3f4d7a4671c9ad97167.jpg";